import styled, { css } from 'styled-components';

import { FontWeightName } from 'types';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaHover } from 'themes/mixins/mediaHover';

import { Headline } from 'components/Headline';

type StyleInfoProps = {
  isActive?: boolean;
  asList?: boolean;
  fontWeight?: FontWeightName;
};
const Wrapper = styled.div`
  font-family: 'LFT Zeno Condensed';
  font-weight: ${({ theme }) => theme.fontWeights.extraLight};
`;

const WrapperHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const WrapperInfo = styled.div`
  display: flex;

  margin: 3rem 0;
`;

const List = styled.div`
  width: 95rem;
  margin-left: 3rem;
`;
const HeadlineInfo = styled(Headline)`
  padding: 0.8rem;
`;

const Info = styled.ul<StyleInfoProps>`
  padding: 0.8rem;

  ${({ asList }) =>
    asList
      ? css`
          width: auto;
          border-top: 1px solid silver;
          font-weight: 500;
        `
      : ` width: 22%;
          border-right: 1px solid silver;
          padding-left: 0;
        `};
`;
Info.displayName = 'Info';

const Li = styled.li<StyleInfoProps>`
  display: flex;
  flex-direction: column;

  margin-bottom: 0.5rem;

  color: ${({ isActive }) => (isActive ? pickColor('black') : pickColor('red'))};
  text-decoration: ${({ isActive }) => (isActive ? 'underline' : 'none')};
  font-weight: ${({ isActive }) => (isActive ? '500' : 'inherit')};

  ${mediaHover(css`
    color: ${pickColor('grayDark')};

    text-transform: uppercase;
  `)}
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
`;

export { Wrapper, WrapperHeader, WrapperInfo, Info, Li, List, HeadlineInfo, Img };
